import React, {useState} from 'react';
import Button from "@mui/material/Button";
import {FormGrid} from "../../checkout/components/billingData/DataForm";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {DeleteOutline} from "@mui/icons-material";


function CategoryCard({category, id, storeCategory, deleteCategory}) {
    const [newCategory, setNewCategory] = useState({id: '', label: '', ...category});

    const onChange = (key, value) => {
        newCategory[key] = value;
        setNewCategory({...newCategory});
    }

    return <div className="categorycard">
        <Grid container spacing={2} paddingTop={3}>
            {id === 'new-category' ? <FormGrid key={'id'} size={{xs: 12}}>
                <FormLabel htmlFor="name">
                    Id
                </FormLabel>
                <TextField
                    id='id'
                    type="text"
                    size="small"
                    value={newCategory.id}
                    onChange={(event) => onChange('id', event.target.value)}
                />
            </FormGrid> : <Typography variant={'h6'}>
                {id}
                <IconButton onClick={() => deleteCategory(id)}>
                    <DeleteOutline/>
                </IconButton>
            </Typography>}

            <FormGrid key={'label'} size={{xs: 12}}>
                <FormLabel htmlFor="label">
                    Label
                </FormLabel>
                <TextField
                    id='label'
                    type="text"
                    size="small"
                    value={newCategory.label}
                    onChange={(event) => onChange('label', event.target.value)}
                />
            </FormGrid>
        </Grid>
        <Button onClick={() => {
            storeCategory(newCategory, id === 'new-category' ? newCategory.id : id)
            setNewCategory({id: '', label: ''});
        }}>Submit</Button>
    </div>;
}

export default CategoryCard;
